import { FunctionComponent, useState } from 'react';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { PropertyTypeSwitcher } from './subcomponents/PropertyTypeSwitcher/PropertyTypeSwitcher';
import { PriceTrends } from './subcomponents/PriceTrends/PriceTrends';
import { MarketInsightsPriceTrend } from './types';
import {
  SuburbPageMarketInsightsDescription,
  SuburbPageMarketInsightsDescriptionProps,
} from './subcomponents/SuburbPageMarketInsightsDescription/SuburbPageMarketInsightsDescription';
import { StyledProptrackLogoBrickSource } from '../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

interface SuburbPageMarketInsightsBrickProps {
  title: string;
  subtitle: string;
  propertyTypes: string[];
  defaultPropertyType: string;
  priceTrends: MarketInsightsPriceTrend[] | null;
  description: SuburbPageMarketInsightsDescriptionProps | null;
}

export const SuburbPageMarketInsightsBrick: FunctionComponent<
  SuburbPageMarketInsightsBrickProps
> = ({ title, subtitle, propertyTypes, defaultPropertyType, priceTrends, description }) => {
  const [activePropertyType, setActivePropertyType] = useState(defaultPropertyType);

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      {priceTrends && (
        <>
          <PropertyTypeSwitcher
            activePropertyType={activePropertyType}
            propertyTypes={propertyTypes}
            setActivePropertyType={setActivePropertyType}
          />
          <PriceTrends activePropertyType={activePropertyType} priceTrends={priceTrends} />
          {description && <SuburbPageMarketInsightsDescription {...description} />}
          <StyledProptrackLogoBrickSource />
        </>
      )}
    </ContentBrick>
  );
};

export const SuburbPageMarketInsightsBrickWithData: FunctionComponent = () => {
  const marketInsights = useSuburbPageQuery()?.data?.suburbPageBySlug?.marketInsights;
  if (!marketInsights) return null;

  const { title, subtitle, propertyTypes, defaultPropertyType, priceTrends, description } =
    marketInsights;

  return (
    <SuburbPageMarketInsightsBrick
      title={title}
      subtitle={subtitle}
      propertyTypes={propertyTypes}
      defaultPropertyType={defaultPropertyType}
      priceTrends={priceTrends}
      description={description}
    />
  );
};
